import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {

        // 查看/修改获取单条
        GetById(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.GoodsListNum = []
            $http.get("api/SummerClass/GetById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = util.filterAndSetData(this.form, Data) //过滤数据


                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    this.Customer = this.form.AgentId + '-' + Data.C_Name + '-' + Data.AgentName
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress //收货地址
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话
                    this.payList = cloneDeep(Data.ListMeetPay)
                    this.ZqwPlatform_GetClassList(this.form.SchoolId)
                    this.storeAgentStyle = Data.AgentStyle
                    if (this.form.ChooseAgentId == 0) {
                        this.form.ChooseAgentId = ''
                    }
                    this.storeChooseAgentId = Data.ChooseAgentId
                    if (this.form.AgentStyle == 2) {
                        this.form.ChooseAgentId = this.form.AgentId
                    }
                    for (let i = 0; i < Data.GoodsList.length; i++) {

                        if (Data.GoodsList[i].ProId == 736) {
                            this.stockNum = Data.GoodsList[i].ProNum
                        }
                    }
                    if (Data.OrderStatus == 1 || Data.OrderStatus == 15 || Data.OrderStatus == 11) {
                        // OrderStatus == 1法务审核通过，OrderStatus=15  内控审核不通过  OrderStatus=11 凭证审核不通过的时候，只能修改 支付信息和库存发货
                        this.showData.isReadOnly = true
                    }
                    this.schoolConsignee.Consignee = Data.SchoolConsignee
                    this.schoolConsignee.ConsigneeAddress = Data.SchoolAddress
                    this.schoolConsignee.ConsigneeAreaId = Data.SchoolAreaId
                    this.schoolConsignee.ConsigneeCityId = Data.SchoolCityId
                    this.schoolConsignee.ConsigneeProvId = Data.SchoolProvincesId
                    this.schoolConsignee.ConsigneeTel = Data.SchoolConsigneeTel


                });
            });
        },
        //获取班级列表 api/Class/ZqwPlatform_GetClassList
        ZqwPlatform_GetClassList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/Class/ZqwPlatform_GetClassList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.ClassLists = Data
                    //this.openClassList[0].ClassLists = Data
                    this.openClassList = []
                    if (this.form.ClassList.length > 0) {
                        // 获取单条赋值
                        let n = this.form.ClassNum - this.form.ClassList.length

                        if (n > 0) {
                            for (let i = 0; i < this.form.ClassList.length; i++) {
                                if (this.form.ClassList[i].ClassId) {
                                    this.openClassList.push({
                                        ClassId: this.form.ClassList[i].ClassId,
                                        ClassLists: this.ClassLists
                                    })
                                } else {
                                    // 提交相同班级后创建班级
                                    this.openClassList.push({
                                        ClassId: this.form.ClassList[i],
                                        ClassLists: this.ClassLists
                                    })
                                }
                            }
                            for (let i = 0; i < n; i++) {
                                this.openClassList.push({
                                    ClassId: '',
                                    ClassLists: this.ClassLists
                                })
                            }
                        } else {
                            for (let i = 0; i < this.form.ClassList.length; i++) {
                                if (this.form.ClassList[i].ClassId) {
                                    this.openClassList.push({
                                        ClassId: this.form.ClassList[i].ClassId,
                                        ClassLists: this.ClassLists
                                    })
                                } else {
                                    // 提交相同班级后创建班级
                                    this.openClassList.push({
                                        ClassId: this.form.ClassList[i],
                                        ClassLists: this.ClassLists
                                    })
                                }
                            }
                        }

                    } else {
                        for (let i = 0; i < this.form.ClassNum; i++) {
                            this.openClassList.push({
                                ClassId: '',
                                ClassLists: this.ClassLists
                            })
                        }
                    }
                    if (Data.length == 0) {
                        this.dialogVisible = true
                    }
                });
            });
        },
        // 获取经销商代理商
        GetAgentBySchoolId(PackageId, SchoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                PackageId: PackageId,
                SchoolId: SchoolId
            };

            $http.get("api/MeetOrder/GetAgentBySchoolId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.AgentLists = Data
                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址

                        if (this.SchoolConsigneeList[i].IsDefault == 1) {

                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id

                            //设置地址
                            this.schoolConsignee.ConsigneeProvId = this.SchoolConsigneeList[i].ConsigneeProvince
                            this.schoolConsignee.ConsigneeCityId = this.SchoolConsigneeList[i].ConsigneeCity
                            this.schoolConsignee.ConsigneeAreaId = this.SchoolConsigneeList[i].ConsigneeArea
                            this.schoolConsignee.ConsigneeAddress = this.SchoolConsigneeList[i].ConsigneeAdress
                            this.schoolConsignee.Consignee = this.SchoolConsigneeList[i].Consignee
                            this.schoolConsignee.ConsigneeTel = this.SchoolConsigneeList[i].ConsigneeTel


                        }
                    }
                });
            });
        },
        //新增园所网络信息 MeetOrder/AddSchoolContract
        AddSchoolContract() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/AddSchoolContract", Object.assign({}, params, this.netWorkData)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form.ContractId = Data.ContractId
                    this.PushOrderAdd()
                });
            });
        },
        //新增MeetOrder/PushOrderAdd
        PushOrderAdd() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/PushOrderAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;

                util.doResult(this, res, () => {
                    this.loading = false;
                    this.$notify({
                        title: '成功',
                        message: '下单成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false
                });
            });
        },

        //修改提交
        PushOrderMoify() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/PushOrderMoify", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;

                util.doResult(this, res, () => {
                    this.loading = false;
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false
                });
            });
        },
        // GET /api/MeetOrder/GetSchoolContractType
        GetSchoolContractType(SchoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId,
                OrderId: this.form.OrderId
            };

            $http.get("api/MeetOrder/GetSchoolContractType", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    //IsEdit:0 可编辑开课完整信息
                    //IsEdit:1 只能编辑开课申请表
                    //IsEdit:2 不可编辑开课完整信息
                    this.showData.IsEdit = Data.IsEdit
                    if (Data.ContractId > 0) {
                        this.netWorkData.ContractId = Data.ContractId
                        this.GetContractById(Data.ContractId)
                    } else if (this.storageNetwork) {
                        // 切换园所，清空园所信息
                        this.netWorkData = this.getSchoolNetWork()
                        this.netWorkData.SchoolId = this.form.SchoolId
                    }

                });
            });
        },

        //获取库存数量 MeetOrder/GetAgentPushRentInfo
        GetAgentPushRentInfo() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: this.form.ChooseAgentId,
                PackageId: this.form.PackageId,
                ClassNum: 1000
            };

            $http.get("api/MeetOrder/GetAgentPushRentInfo", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    if (Data.UsePushNum == 0 && this.form.AgentStyle == 1) {
                        this.form.IsUseAgentStock = 0
                    }
                    if (this.stockNum > Data.UsePushNum) {
                        this.stockNum = 1
                    }
                    this.stockTotalNum = Data.UsePushNum
                    if (this.form.GoodsList.length > 0) {
                        for (let i = 0; i < this.form.GoodsList.length; i++) {
                            if (this.form.GoodsList[i].ProId == 736) {
                                this.stockNum = this.form.GoodsList[i].ProNum
                            }
                        }
                    }

                });
            });
        },
        //获取单条园所合作信息 MeetOrder/GetContractById
        GetContractById(ContractId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ContractId: ContractId
            };

            $http.get("api/MeetOrder/GetContractById", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.storageNetwork = true
                    this.netWorkData = util.filterAndSetData(this.netWorkData, Data) //过滤数据
                    this.netWorkData.NetworkOperator = Data.NetworkOperators
                    this.netWorkData.NetworkType = Data.NetworkTypes

                    if (this.showData.IsEdit == 1 && this.form.OrderId == 0) {
                        this.netWorkData.CooperationPics = []
                    }
                });
            });
        },
        // 修改园所合作信息提交MeetOrder/UpdateSchoolContract
        UpdateSchoolContract() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/UpdateSchoolContract", Object.assign({}, params, this.netWorkData)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.PushOrderMoify()
                });
            });
        },
        CheckSchoolAreaRole(SchoolId, AgentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId,
                AgentId: AgentId
            };
            $http.get("api/School/CheckSchoolAreaRole", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.IsAreaRole = Data.IsAreaRole
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addD55Order/services.js